import { Group, Rect, Text } from "react-konva";
import TemplateShape from "../TemplateShape";
import { api } from "../../../lib/api";

// AOE Templates (circle/cone/line) + their floating Edit/Delete action buttons, extracted
// verbatim from MapCanvas.jsx (Phase 42 refactor) — no behavior changes.
export function MapTemplatesLayer({ templates, activeTool, isGm, myMemberId, selectedTemplateId, setSelectedTemplateId, handleOverlayClick, onTemplateDragEnd, gameId, setTemplateEditing, removeTemplateLocal }) {
  return (
    <>
      {templates.map((t) => (
        <TemplateShape
          key={t.id}
          template={t}
          canEdit={!activeTool && (isGm || t.created_by === myMemberId)}
          onDragEnd={onTemplateDragEnd}
          onSelect={(e) => {
            if (handleOverlayClick(e)) return;
            e.cancelBubble = true;
            setSelectedTemplateId(selectedTemplateId === t.id ? null : t.id);
          }}
          isSelected={selectedTemplateId === t.id}
        />
      ))}
      {selectedTemplateId && templates.filter((t) => t.id === selectedTemplateId && (isGm || t.created_by === myMemberId)).map((t) => (
        <Group key={`tpl-actions-${t.id}`} x={t.x - 46} y={t.y - (t.shape === "circle" ? t.size / 2 + 32 : 32)}>
          <Group
            data-testid={`template-edit-button-${t.id}`}
            onClick={(e) => { e.cancelBubble = true; setTemplateEditing(t); setSelectedTemplateId(null); }}
            onTap={(e) => { e.cancelBubble = true; setTemplateEditing(t); setSelectedTemplateId(null); }}
          >
            <Rect width={62} height={24} cornerRadius={12} fill="#322216dd" stroke="#D4AF37" strokeWidth={1} />
            <Text text="Edit" width={62} height={24} align="center" verticalAlign="middle" fontSize={11} fill="#D4AF37" fontStyle="bold" />
          </Group>
          <Group
            x={66}
            data-testid={`template-delete-${t.id}`}
            onClick={async (e) => {
              e.cancelBubble = true;
              await api.delete(`/games/${gameId}/templates/${t.id}`);
              removeTemplateLocal(t.id);
              setSelectedTemplateId(null);
            }}
            onTap={async (e) => {
              e.cancelBubble = true;
              await api.delete(`/games/${gameId}/templates/${t.id}`);
              removeTemplateLocal(t.id);
              setSelectedTemplateId(null);
            }}
          >
            <Rect width={26} height={24} cornerRadius={12} fill="#322216dd" stroke="#D90429" strokeWidth={1} />
            <Text text="X" width={26} height={24} align="center" verticalAlign="middle" fontSize={12} fill="#D90429" fontStyle="bold" />
          </Group>
        </Group>
      ))}
    </>
  );
}
